import { render, staticRenderFns } from "./field-file.vue?vue&type=template&id=7ce7cefd&scoped=true&"
import script from "./field-file.vue?vue&type=script&lang=js&"
export * from "./field-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce7cefd",
  null
  
)

export default component.exports